<template>
  <div class="code">
    <div class="code-top-img">
      <div class="title">在线编程专项练习</div>
      <div>术业有专攻，亦或八项皆全能</div>
    </div>
    <div class="box">
      <div class="navbar">
        题目类型：
        <navbar-item
          v-for="(item, index) in cptMenuItemList"
          :key="index"
          :item="item"
          :activeItem="activeItem"
          @onClick="nowNavbarItem"
        />
      </div>
      <div class="code-bd">
        <code-cell
          v-for="(item, index) in questions"
          :paperId="paperId"
          :item="item"
          :key="index"
        />
        <!-- <my-pagination
          class="company-bd-pagination" v-if="total > 10"
          @changeSizeHandle="changeSizeHandle"
          @currentChangeHandle="currentChangeHandle"
          :currentPage="currentPage"
          :size="pageSize"
          :total="total"
          background
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import NavbarItem from '@/components/practice/code/navbar-item'
import CodeCell from '@/components/practice/code/code-cell'
import { menuItemList } from './config'
import { LOGIN_API } from "@/api.js";
export default {
  data() {
    return {
      activeItem: '基本算法',
      value: 3.5,

      paperId: '',
      total: 0, // 总条数
      pageSize: 10,
      currentPage: 1,
      cptMenuItemList: [],
      questions: [],
    }
  },
  components: {
    NavbarItem,
    CodeCell,
  },
  mounted() {
    const queryTitle = this.$route.query.title
    if (queryTitle) {
      this.activeItem = queryTitle
    }
    window.scrollTo(0, 0)
    this.loadCategory()
  },
  methods: {
    nowNavbarItem(e) {
      this.activeItem = e.title
      this.paperId = e._id
      this.loadQuestions()
    },
    //分页相关
    changeSizeHandle(val) {
      this.pageSize = val // 改变每页显示的条数
      this.getTableData()
    },
    currentChangeHandle(val) {
      this.currentPage = val // 改变默认的页数
      this.getTableData() // 切换页码时，要获取每页显示的条数
    },
    loadQuestions() {
      const post = {
        paperId: this.paperId,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/proList`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            this.questions = res.data.result
            this.total = this.questions.length
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    loadCategory() {
      this.$axios
        .get(`${LOGIN_API}/customer/api/paperList`)
        .then((res) => {
          if (res.data.errno == 0) {
            console.log(res.data.result, 'res')
            this.cptMenuItemList = res.data.result
            let hasItem = this.cptMenuItemList.filter(
              (item) => item.title == this.activeItem
            )
            if (hasItem.length > 0) {
              this.paperId = hasItem[0]._id
              this.activeItem = hasItem[0].title
            }
            this.loadQuestions()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
  },
}
</script>

<style lang='scss' scoped>
.code {
  background-color: #fff;
  color: #333;
  .box {
    background: #fff url('/static/images/wbg.png') repeat-x;
    padding: 20px;
    min-height: 500px;
  }

  .code-top-img {
    width: 100%;
    height: 200px;
    margin-top: -40px;
    text-align: center;
    padding-top: 50px;
    font-size: 14px;
    font-weight: 330;
    color: #666;
    background: url('~@/static/images/top-com-code.png') no-repeat center top;
    .title {
      font-size: 28px;
      padding: 20px;
    }
  }
  .navbar {
    display: flex;
    width: 1000px;
    padding: 20px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 32px;
    border: 1px solid #eff0f2;
    background: #fff;
  }
  .code-title {
    text-align: center;
    padding: 10px 0 30px 0;
    position: relative;
    div {
      font-size: 24px;
      padding-bottom: 10px;
      font-weight: 340;
    }
    .rate {
      font-size: 14px;
      line-height: 30px;
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      padding: 20px 0;
      span {
        padding-right: 10px;
      }
      .el-rate__icon {
        font-size: 20px !important;
      }
    }
  }

  .code-bd {
    width: 1020px;
    margin: auto;
    padding: 12px 0px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/practice/code/index.vue